import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/source-templates")({
  component: () => (
    <Breadcrumb label="Source Templates" to="/source-templates">
      <Outlet />
    </Breadcrumb>
  ),
});
